import getFloatFromPriceString from '~/src/utils/helpers/getFloatFromPriceString';

/**
 * check is Int
 * @param n
 * @return {boolean}
 */
function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

/**
 * return parsed price
 * @param {string|number} currentValue
 * @return {string}
 */
export default (currentValue) => {
    const value = getFloatFromPriceString(currentValue);

    if (isInt(value) === true) {
        return value.toString();
    }

    return (value.toString().slice(-3) === '.00' ? value : parseFloat(value).toFixed(2)).toString();
};
